module.exports = __webpack_public_path__ + "static/media/Mask Group 158.2396f89f.svg";